import { ReactNode, useContext } from 'react'
import { observer } from 'mobx-react-lite'

import { ToolbarResponsiveContext } from './stores/ToolbarResponsiveStore'

export interface ResponsiveShowHideProps {
  more?: boolean
  toolbar?: boolean
}

export const ShowFor = observer(
  ({
    children,
    toolbar,
    more,
    sceneA = false,
    sceneB = false,
    sceneC = false,
    sceneD = false,
  }: {
    children: ReactNode
    sceneA?: boolean
    sceneB?: boolean
    sceneC?: boolean
    sceneD?: boolean
  } & ResponsiveShowHideProps) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const responsiveStore = useContext(ToolbarResponsiveContext)!
    const shouldShow =
      (sceneA && responsiveStore.isSceneA) ||
      (sceneB && responsiveStore.isSceneB) ||
      (sceneC && responsiveStore.isSceneC) ||
      (sceneD && responsiveStore.isSceneD)
    if ((shouldShow && toolbar) || (!shouldShow && more)) return <>{children}</>
    return null
  },
)
